import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function DisclaimerPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <div className="pt-24 pb-16">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-3xl mx-auto">
            <button
              onClick={() => navigate('/')}
              className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-500 mb-6 transition-colors"
            >
              <i className="ri-arrow-left-line" />
              {t('back_to_home')}
            </button>

            <h1 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-950 mb-6">
              Disclaimer
            </h1>

            <div className="prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed space-y-6">
              <p className="text-lg font-medium text-foreground-900">
                This is an independent informational website and is not the official CSSBuy website. We are not affiliated with, endorsed by, or sponsored by CSSBuy.
              </p>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">Independence Statement</h2>
              <p>
                CSSBuy Spreadsheet (cssbuybr.my) operates as an independent resource providing information about products, shipping, quality control, and buying guides. We do not sell products, process payments, or handle shipping logistics. All transactions are conducted directly between the buyer and CSSBuy or the respective sellers.
              </p>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">Information Accuracy</h2>
              <p>
                While we make every effort to keep information accurate and up-to-date, product details, prices, shipping costs, and seller information may change without notice. We do not guarantee the accuracy of any information provided on this website. Always verify critical information directly on the official CSSBuy platform before making purchasing decisions.
              </p>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">External Links</h2>
              <p>
                This website contains links to external websites, including kaspreadsheet.com. We are not responsible for the content, privacy practices, or policies of these external websites. Clicking external links is done at your own risk. We recommend reviewing the terms and privacy policies of any external website before providing personal information or making purchases.
              </p>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">Risk Acknowledgment</h2>
              <p>
                International purchasing involves inherent risks, including but not limited to: seller reliability issues, product quality discrepancies, shipping delays, customs inspections, import duties, and potential fraud. By using the information on this website, you acknowledge that you understand these risks and agree that we are not liable for any losses or damages resulting from your purchasing decisions.
              </p>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">No Guarantees</h2>
              <p>
                We do not guarantee the safety, legitimacy, or quality of any sellers, products, or services mentioned on this website. We do not make any claims about guaranteed delivery, product authenticity, or seller trustworthiness. All buying decisions are your own responsibility.
              </p>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">Contact</h2>
              <p>
                If you have any questions about this disclaimer, please contact us through our <button onClick={() => navigate('/contact')} className="text-primary-600 hover:underline">contact page</button>.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}